import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
//import createHistory from 'history/createBrowserHistory';
import { createBrowserHistory } from 'history';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import reducers from '../redux/reducers';

import api from '../helpers/middleware';

const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);
const middlewares = [thunk, routeMiddleware, api];

const store = createStore(
  combineReducers({
    ...reducers,
    router: routerReducer
  }),
  compose(applyMiddleware(...middlewares))
);
export { store, history };